import { useSelector } from 'react-redux';
import { isSharingOnboardingABEnabled } from 'reactApp/appHelpers/featuresHelpers/features/sharingOnboarding';
import { UserSelectors } from 'reactApp/modules/user/user.selectors';

export function useOnboardingEnabled(contextEnabled = false) {
    const isPaid = useSelector(UserSelectors.isPaidUser);
    const isCorp = useSelector(UserSelectors.isCorpUser);
    const paidFeaturesAvailable = isPaid || isCorp;
    return {
        onboardingPaidUsers: contextEnabled && paidFeaturesAvailable && isSharingOnboardingABEnabled,
        onboardingFreeUsers: contextEnabled && !paidFeaturesAvailable && isSharingOnboardingABEnabled,
        onboardingAllUsers: contextEnabled && isSharingOnboardingABEnabled,
    } as const;
}
